jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;
    // Prevent initial "jump" by setting the parallax CSS var immediately,
    // before GSAP/ScrollTrigger async readiness events run.
    primeInitialParallaxOffset();
    whenGsapReady(() => {
      whenScrollReady(() => {
        initAboutBanner();
      });
    });
  });

  function primeInitialParallaxOffset() {
    const blocks = document.querySelectorAll(".js-about-banner");
    if (!blocks.length) return;

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      const parallaxTarget = block.querySelector(".js-ab-parallax");
      if (!parallaxTarget) return;

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 240;

      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1);

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2;
        return -(t * strength * factor);
      };

      // Mirror the non-ScrollTrigger fallback progress calculation.
      const rect = block.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const total = rect.height + vh;
      const p = clamp((vh - rect.top) / total, 0, 1);
      const off = computeOffset(p);

      block.style.setProperty("--ab-offset", `${off}px`);
    });
  }

  function initAboutBanner() {
    const blocks = document.querySelectorAll(".js-about-banner");
    if (!blocks.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      if (block.dataset.abInit === "1") return;
      block.dataset.abInit = "1";

      const parallaxTarget = block.querySelector(".js-ab-parallax");
      // Don't apply transform-based reveal animations to the parallax image,
      // because it already relies on a CSS transform for positioning.
      const items = Array.from(block.querySelectorAll(".js-ab-item")).filter(
        (el) => el !== parallaxTarget,
      );
      const fadeOnlyItems = parallaxTarget ? [parallaxTarget] : [];

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 240;

      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1);

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2;
        return -(t * strength * factor);
      };

      const applyOffset = (progress) => {
        if (!parallaxTarget) return;
        const off = computeOffset(progress);
        block.style.setProperty("--ab-offset", `${off}px`);
      };

      const revealDuration = 0.95;
      const revealStagger = 0.08;

      if (reduceMotion) {
        if (items.length) {
          gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        }
        if (fadeOnlyItems.length) {
          gsap.set(fadeOnlyItems, { autoAlpha: 1 });
        }
        if (parallaxTarget) block.style.setProperty("--ab-offset", "0px");
        return;
      }

      // Reveal
      if (items.length) {
        gsap.set(items, { autoAlpha: 0, y: 18 });
        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: revealDuration,
          ease: "power3.out",
          stagger: revealStagger,
          clearProps: "transform",
        };
        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: block,
            start: "top 78%",
            once: true,
            invalidateOnRefresh: true,
          };
        }
        gsap.to(items, vars);
      }

      // Fade-in only for the parallax image to avoid transform snapping.
      if (fadeOnlyItems.length) {
        const small = fadeOnlyItems[0];
        const main = block.querySelector(".ab__img--main");
        const mainImg = main ? main.querySelector("img") : null;

        // Keep it after the main image reveal starts, but not too late.
        const afterMainStartBufferMs = 250;
        const afterMainLoadBufferMs = 50;

        const fadeInSmall = () => {
          gsap.to(small, {
            autoAlpha: 1,
            duration: 0.75,
            ease: "power2.out",
            overwrite: "auto",
          });
        };

        const revealSmallAfterMain = () => {
          // If the main image hasn't loaded yet, wait for it.
          if (mainImg && !mainImg.complete) {
            mainImg.addEventListener(
              "load",
              () => setTimeout(fadeInSmall, afterMainLoadBufferMs),
              { once: true },
            );
            return;
          }

          // Otherwise, sequence shortly after the main reveal begins.
          const mainIdx = main ? items.indexOf(main) : -1;
          const delayMs =
            mainIdx >= 0
              ? Math.round(
                  mainIdx * revealStagger * 1000 + afterMainStartBufferMs,
                )
              : afterMainStartBufferMs;
          setTimeout(fadeInSmall, delayMs);
        };

        // Keep it hidden until we explicitly reveal it.
        gsap.set(small, { autoAlpha: 0 });

        if (ScrollTrigger) {
          ScrollTrigger.create({
            trigger: block,
            start: "top 78%",
            once: true,
            invalidateOnRefresh: true,
            onEnter: revealSmallAfterMain,
            onRefresh: revealSmallAfterMain,
          });
        } else {
          revealSmallAfterMain();
        }
      }

      // Parallax only for small image
      if (!parallaxTarget) return;

      if (ScrollTrigger) {
        const st = ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => applyOffset(self.progress),
          onRefresh: (self) => applyOffset(self.progress),
        });
        applyOffset(st.progress);
        return;
      }

      // Fallback without ScrollTrigger
      let ticking = false;
      const update = () => {
        ticking = false;
        const rect = block.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height + vh;
        const p = clamp((vh - rect.top) / total, 0, 1);
        applyOffset(p);
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    });
  }
});

